import { create } from 'zustand';
import type { FootingAnalysisRequest } from './types';

interface State {
  request: FootingAnalysisRequest;
  setColumn: (patch: Partial<FootingAnalysisRequest['column']>) => void;
  setLoads: (patch: Partial<FootingAnalysisRequest['loads']>) => void;
  setSoil: (patch: Partial<FootingAnalysisRequest['soil']>) => void;
  setUserDimensions: (patch: { B_m_user?: number | null; L_m_user?: number | null; h_m_user?: number | null }) => void;
  setMaterials: (patch: Partial<Pick<FootingAnalysisRequest, 'fc' | 'fy' | 'cover_cm' | 'combo'>>) => void;
  loadRequest: (r: FootingAnalysisRequest) => void;
}

const defaults: FootingAnalysisRequest = {
  column: { bc_cm: 40, hc_cm: 40 },
  loads: { P_D: 50_000, P_L: 15_000, Mx_D: 0, Mx_L: 0, My_D: 0, My_L: 0 },
  soil: { sigma_adm_kgf_cm2: 2.0, df_m: 1.5, gamma_soil_kgf_m3: 1800, gamma_concrete_kgf_m3: 2400 },
  B_m_user: null,
  L_m_user: null,
  h_m_user: null,
  combo: 'E060',
  fc: 210,
  fy: 4200,
  cover_cm: 7.5,
};

export const useFootingAnalysisStore = create<State>((set) => ({
  request: defaults,
  setColumn: (patch) =>
    set((s) => ({ request: { ...s.request, column: { ...s.request.column, ...patch } } })),
  setLoads: (patch) =>
    set((s) => ({ request: { ...s.request, loads: { ...s.request.loads, ...patch } } })),
  setSoil: (patch) =>
    set((s) => ({ request: { ...s.request, soil: { ...s.request.soil, ...patch } } })),
  setUserDimensions: (patch) => set((s) => ({ request: { ...s.request, ...patch } })),
  setMaterials: (patch) => set((s) => ({ request: { ...s.request, ...patch } })),
  loadRequest: (r) => set({ request: r }),
}));
